import { cn } from './cn.js';

import type { CSSProperties, HTMLAttributes, ReactElement, ReactNode } from 'react';

interface GlassCardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  glow?: boolean;
  hover?: boolean;
}

const glassStyle: CSSProperties = {
  background: 'var(--glass-bg)',
  backdropFilter: 'blur(var(--glass-blur-medium, 16px))',
  WebkitBackdropFilter: 'blur(var(--glass-blur-medium, 16px))',
  border: '1px solid var(--glass-border)',
  boxShadow: 'var(--glass-shadow)',
};

const glowStyle: CSSProperties = {
  ...glassStyle,
  boxShadow: 'var(--glass-shadow), var(--glass-glow)',
};

export function GlassCard({
  className,
  children,
  glow,
  hover,
  style,
  ...props
}: GlassCardProps): ReactElement {
  return (
    <div
      className={cn(
        'rounded-xl',
        hover === true &&
          'transition-all duration-[var(--dur,180ms)] ease-[var(--ease)] hover:translate-y-[-1px] hover:shadow-[var(--glass-glow-hover)]',
        className,
      )}
      style={{
        ...(glow === true ? glowStyle : glassStyle),
        ...style,
      }}
      {...props}
    >
      {children}
    </div>
  );
}

interface GlassCardHeaderProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export function GlassCardHeader({
  className,
  children,
  ...props
}: GlassCardHeaderProps): ReactElement {
  return (
    <div
      className={cn('px-5 py-4', className)}
      style={{ borderBottom: '1px solid var(--glass-border-subtle)' }}
      {...props}
    >
      {children}
    </div>
  );
}

interface GlassCardContentProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export function GlassCardContent({
  className,
  children,
  ...props
}: GlassCardContentProps): ReactElement {
  return (
    <div className={cn('px-5 py-4', className)} {...props}>
      {children}
    </div>
  );
}
